

import { Vue } from "../../constants/constants";
import { serverData } from "../../data-from-server";

import { isRTL } from "../../helpers";
import { pushGoogleAnalytics4Event } from "../../lib/google-analytics";
import { GA4Events } from "../../lib/google-analytics/config";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("restaurant-scripts", {
  data() {
    return {
      staticContent,
      restaurant: serverData.restaurantHeader,
      restaurantBaseUrl: serverData.restaurantBaseUrl,
      name: "scripts",
    };
  },
  computed: {
    profile() {
      return this.$root.profile;
    },
    deliveryStatus() {
      return this.$root.deliveryStatus;
    },
    flatAreas() {
      return this.$root.flatAreas;
    },
    restaurantPage() {
      return this.$root.restaurantPage;
    },
    pageReferrer() {
      if ("referrer" in document) {
        return document.referrer;
      } else {
        return null;
      }
    },
  },
  mounted() {
    if (this.restaurant) {
      var basketData = {
        // tax: this.restaurant.taxRate / 100,
        // taxOnDelivery: this.restaurant.taxOtnDelivery,
        minimumOrderValue: this.restaurant.minimumOrderValue,
      };
      this.$store.commit("updateBasketData", basketData);

      // out of the box Google event
      window["gtag"]("event", "view_item_list");

      const onlineOrderingEnabled =  this.restaurant.onlineOrdering && this.restaurant.branchOrderingEnabled;
      const deliverToUser = onlineOrderingEnabled && this.restaurant.branchDeliversToLocation;
      pushGoogleAnalytics4Event(this.profile, GA4Events.view.restaurant, {
        'Online_Ordering_Enabled': onlineOrderingEnabled,
        'Delivers_To_User': deliverToUser,
        referral: this.pageReferrer,
      });
    }


    if (
      window.location.href.indexOf("/group") > 0 &&
      window.location.href.indexOf("?groupUUID") > 0
    ) {
      this.$root.setIsGroupOrderPage(true);
      if (!!navigator.platform && /iPhone|iPod/.test(navigator.platform)) {
        window.location.href = window.location.href.replace(
          window.location.origin,
          "elmenusgroup:"
        );
      }
      let groupLangUrl = isRTL
        ? window.location.href.replace("/ar/group/", "/group/")
        : window.location.href.replace("/group/", "/ar/group/");

      this.$root.setGroupLangUrl(groupLangUrl);

      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let groupPageGroupUUID = params.get("groupUUID");
      let groupPageAreaUUID = params.get("areaUUID");

      this.$root.setGroupPageData(groupPageGroupUUID, groupPageAreaUUID)

      this.$store.commit(
        "updateUserBasketStateBasket",
        groupPageGroupUUID
      );
      this.restaurant && this.$store.dispatch("GET_BASKET_STATE");
      this.$store.dispatch("GET_GROUP_BASKET_SUMMARY", groupPageGroupUUID);
      this.$root.setUserAreaCookie(groupPageAreaUUID);
      if (this.windowWidth > 1024) {
        this.$root.changeGroupVisibility(true);
      }
    }

    if (this.restaurantPage.reviewsTab.selectedReview) {
      this.$root.handleReviewModal('show')
    }
  },
  updated() {},
});
